
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/invitation/revision",
      function () {
        return require("private-next-pages/bcks/invitation/revision.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/invitation/revision"])
      });
    }
  